const layout = {
    default: 'value',
    initialized: false,
    loginImageIndex:null,
    isReloadIframe:false
};

export default layout;